import React from "react";
import { useTranslation } from "react-i18next";

const RefundAndShippingpolicy = () => {
	const { i18n } = useTranslation();
	const isAr = (i18n.language || "ar").startsWith("ar");
	const lastUpdated = "2026-03-11";

	return (
		<div style={{ ...styles.page, direction: isAr ? "rtl" : "ltr" }}>
			<div style={styles.container}>
				<div style={styles.header}>
					<h1 style={styles.title}>سياسات الاسترجاع والاستبدال والشحن</h1>
					<p style={styles.updated}>آخر تحديث: {lastUpdated}</p>
				</div>

				<section style={styles.card}>
					<h2 style={styles.h2}>سياسة الاسترجاع والاسترداد (Refund Policy)</h2>
					<p style={styles.p}>
						نشكر تسوقكم من <strong>Dida Max</strong>. نسعى دائما لتقديم أفضل تجربة تسوق لعملائنا.
					</p>

					<h3 style={styles.h3}>الاسترجاع</h3>
					<p style={styles.p}>
						يمكنك طلب استرجاع المنتج خلال <strong>14 يوما</strong> من تاريخ استلام الطلب، بشرط توفر الشروط التالية:
					</p>
					<ul style={styles.ul}>
						<li style={styles.li}>أن يكون المنتج غير مستخدم وفي حالته الأصلية.</li>
						<li style={styles.li}>أن يكون المنتج في عبوته الأصلية.</li>
						<li style={styles.li}>تقديم رقم الطلب أو إثبات الشراء.</li>
					</ul>

					<h3 style={styles.h3}>المنتجات غير القابلة للاسترجاع</h3>
					<p style={styles.p}>بعض المنتجات لا يمكن استرجاعها أو استرداد قيمتها، مثل:</p>
					<ul style={styles.ul}>
						<li style={styles.li}>منتجات التبغ بعد فتح العبوة.</li>
						<li style={styles.li}>المنتجات الشخصية التي تم استخدامها.</li>
						<li style={styles.li}>المنتجات المخصصة أو المصنوعة حسب الطلب.</li>
					</ul>

					<h3 style={styles.h3}>الاسترداد</h3>
					<p style={styles.p}>
						بعد استلام المنتج المرتجع وفحصه، سنقوم بإبلاغك بحالة طلب الاسترداد.
					</p>
					<p style={styles.p}>
						إذا تمت الموافقة على طلب الاسترداد، سيتم إعادة المبلغ إلى وسيلة الدفع الأصلية خلال
						<strong> 5 إلى 10 أيام عمل</strong>.
					</p>

					<h3 style={styles.h3}>تكاليف الشحن</h3>
					<p style={styles.p}>
						يتحمل العميل تكاليف شحن الإرجاع، إلا في حالة وصول المنتج تالفا أو وجود خطأ في الطلب.
					</p>

					<h3 style={styles.h3}>التواصل معنا</h3>
					<p style={styles.p}>
						لأي استفسار بخصوص سياسة الاسترجاع، يمكنكم التواصل معنا عبر:
					</p>
					<p style={styles.contactLine}><strong>البريد الإلكتروني:</strong> info@didastore.com</p>
					<p style={styles.contactLine}><strong>رقم الهاتف:</strong> +20 123 456 7890</p>
				</section>

				<section style={styles.card}>
					<h2 style={styles.h2}>سياسة الشحن (Shipping Policy)</h2>
					<p style={styles.p}>نشكر تسوقكم من <strong>Dida Max</strong>.</p>

					<h3 style={styles.h3}>معالجة الطلبات</h3>
					<p style={styles.p}>
						يتم تجهيز ومعالجة الطلبات خلال <strong>1 إلى 3 أيام عمل</strong> بعد تأكيد الطلب.
					</p>
					<p style={styles.p}>لا يتم شحن الطلبات في أيام العطل الرسمية أو نهاية الأسبوع.</p>

					<h3 style={styles.h3}>مدة الشحن</h3>
					<p style={styles.p}>تعتمد مدة الشحن على موقع العميل وشركة الشحن، وعادة تكون:</p>
					<ul style={styles.ul}>
						<li style={styles.li}>داخل الدولة: <strong>2 إلى 5 أيام عمل</strong>.</li>
						<li style={styles.li}>الشحن الدولي (إن وجد): <strong>7 إلى 14 يوم عمل</strong>.</li>
					</ul>
					<p style={styles.p}>قد تحدث بعض التأخيرات الخارجة عن إرادتنا بسبب شركات الشحن.</p>

					<h3 style={styles.h3}>تتبع الطلب</h3>
					<p style={styles.p}>
						بمجرد شحن الطلب، سيتم إرسال <strong>رقم تتبع الشحنة</strong> إلى بريدك الإلكتروني أو عبر رسالة نصية إن توفرت.
					</p>

					<h3 style={styles.h3}>المنتجات المقيدة بالعمر</h3>
					<p style={styles.p}>
						بعض المنتجات المتوفرة في متجرنا مثل <strong>منتجات التبغ</strong> مخصصة للبيع للأشخاص الذين تبلغ أعمارهم
						<strong> 18 عاما أو أكثر</strong>.
					</p>
					<p style={styles.p}>
						من خلال إتمام عملية الشراء، يقر العميل بأنه بلغ السن القانوني المسموح به لشراء هذه المنتجات.
					</p>

					<h3 style={styles.h3}>الطرود التالفة أو المفقودة</h3>
					<p style={styles.p}>
						في حال وصول الطلب تالفا أو وجود مشكلة في الشحن، يرجى التواصل معنا خلال <strong>48 ساعة</strong> من استلام الطلب.
					</p>

					<h3 style={styles.h3}>التواصل معنا</h3>
					<p style={styles.p}>لأي استفسار بخصوص الشحن يمكن التواصل معنا عبر:</p>
					<p style={styles.contactLine}><strong>البريد الإلكتروني:</strong> info@didastore.com</p>
					<p style={styles.contactLine}><strong>رقم الهاتف:</strong> +20 123 456 7890</p>
				</section>
			</div>
		</div>
	);
};

const styles = {
	page: {
		minHeight: "100vh",
		backgroundColor: "#f6f7f9",
		padding: "32px 16px",
	},
	container: {
		maxWidth: "980px",
		margin: "0 auto",
	},
	header: {
		background: "linear-gradient(135deg, #1f2937 0%, #374151 100%)",
		borderRadius: "12px",
		color: "#fff",
		padding: "28px 24px",
		marginBottom: "20px",
	},
	title: {
		margin: 0,
		fontSize: "30px",
		fontWeight: 800,
	},
	updated: {
		margin: "10px 0 0",
		color: "#e5e7eb",
		fontSize: "14px",
	},
	card: {
		backgroundColor: "#fff",
		borderRadius: "12px",
		padding: "24px",
		marginBottom: "16px",
		boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
	},
	h2: {
		margin: "0 0 14px",
		color: "#111827",
		fontSize: "24px",
		fontWeight: 800,
	},
	h3: {
		margin: "18px 0 8px",
		color: "#1f2937",
		fontSize: "18px",
		fontWeight: 700,
	},
	p: {
		margin: "8px 0",
		color: "#374151",
		lineHeight: 1.9,
		fontSize: "16px",
	},
	ul: {
		margin: "6px 0 12px",
		paddingInlineStart: "22px",
	},
	li: {
		marginBottom: "8px",
		color: "#374151",
		lineHeight: 1.8,
		fontSize: "16px",
	},
	contactLine: {
		margin: "6px 0",
		color: "#111827",
		fontSize: "16px",
	},
};

export default RefundAndShippingpolicy;
